// DeliveryRouteScreen.js
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchRoutes,
  createRoute,
  updateRoute,
  resetRouteState,
} from '../store/deliveryRouteSlice';
import { fetchPods } from '../store/podSlice';
import PodSelector from '../components/PodSelector';
import DeliveryRoutesList from '../components/DeliveryRoutesList';


const DeliveryRoute = () => {
  const dispatch = useDispatch();
  const { routes, success, isLoading, error } = useSelector((state) => state.deliveryRoute);
  const { pods } = useSelector((state) => state.pods);

  const [form, setForm] = useState({
    routename: '',
    deliverycontactname: '',
    deliverycontactmobile: '',
    vechiclenumber: '',
    podId: '',
    podText: '',
  });

  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    dispatch(fetchRoutes());
    dispatch(fetchPods());
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      alert(isEditing ? 'Delivery route updated!' : 'Delivery route created!');
      setForm({
        routename: '',
        deliverycontactname: '',
        deliverycontactmobile: '',
        vechiclenumber: '',
        podId: '',
        podText: '',
      });
      setIsEditing(false);
      setSelectedId(null);
      dispatch(resetRouteState());
    }
  }, [success, isEditing, dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handlePodSelect = (pod) => {
    setForm({
      ...form,
      podId: pod.id,
      podText: pod.podname,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = { ...form };
    delete payload.podText;

    if (isEditing && selectedId) {
      dispatch(updateRoute({ id: selectedId, formData: payload }));
    } else {
      dispatch(createRoute(payload));
    }
  };

  const handleEdit = (route) => {
    setIsEditing(true);
    setSelectedId(route.id);
    const selectedPod = pods.find((p) => p.id === route.podId);
    setForm({
      ...route,
      podText: selectedPod?.podname || '',
    });
  };

  return (
    <div className="space-y-10 px-6">
      <div className="max-w-4xl bg-white rounded shadow p-6 mx-auto space-y-4">
        <h2 className="text-2xl font-bold mb-4">
          {isEditing ? 'Edit Delivery Route' : 'New Delivery Route'}
        </h2>
        {error && <p className="text-red-500">{error?.message || JSON.stringify(error)}</p>}

        <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
          <input
            type="text"
            name="routename"
            placeholder="Route Name"
            value={form.routename}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded"
            required
          />
          <input
            type="text"
            name="deliverycontactname"
            placeholder="Contact Name"
            value={form.deliverycontactname}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded"
            required
          />
          <input
            type="text"
            name="deliverycontactmobile"
            placeholder="Contact Mobile"
            value={form.deliverycontactmobile}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded"
            required
          />
          <input
            type="text"
            name="vechiclenumber"
            placeholder="Vehicle Number"
            value={form.vechiclenumber}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded"
          />

          <div className="col-span-2">
            <PodSelector
              selectedPod={{ podname: form.podText }}
              onSelect={handlePodSelect}
            />
          </div>

          <div className="col-span-2">
            <button
              type="submit"
              disabled={isLoading}
              className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
            >
              {isLoading ? 'Saving...' : isEditing ? 'Update Route' : 'Create Route'}
            </button>
          </div>
        </form>
      </div>

      <div className="max-w-4xl bg-white rounded shadow p-6 mx-auto">
      <DeliveryRoutesList routes={routes} onEdit={handleEdit} />

      </div>
    </div>
  );
};

export default DeliveryRoute;
